import React, { useState } from "react";
import {
  Row,
  Col,
  Card,
  Form,
  Input,
  Button,
  Typography,
  Alert,
} from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import logo from "../assets/Cognizant-Logo.jpg";


const { Title, Link } = Typography;

const Login = ({ onLoginSuccess }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loginError, setLoginError] = useState("");

  const onFinish = (values) => {
    if (values.username !== 'admin') {
      setLoginError('Invalid username.');
      return;
    }
    if (values.username === 'admin' && values.password === 'admin') {
      setLoginError("");
      console.log("Success:", values);
      onLoginSuccess();
      navigate('/dashboard', { replace: true });
    } else {
      setLoginError('Invalid username or password.');
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  

  return (
    <div className="login-container">
      <Row gutter={0} className="login-row">
        <Col span={14} className="left-section">
          <div className="overlay"></div>
          <div
            className="left-content"
            /*style={{ backgroundImage: `url(${bgImage})` }}*/
          >
            <img src={logo} alt="Cognizant Logo" className="logo" />
            <Title level={1} className="welcome-title">
              Hey! Welcome
            </Title>
            <strong className="subtext">AI-Driven PR Processing</strong>
          </div>
        </Col>
        <Col span={10} className="right-section">
          <Card className="login-card" title="Login Page">
            {loginError && (
              <Alert
                message={loginError}
                type="error"
                showIcon
                closable
                onClose={() => setLoginError("")}
                style={{ marginBottom: 16 }}
              />
            )}
            <Form
              form={form}
              name="login"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Form.Item
                name="username"
                rules={[
                  { required: true, message: "Please input your Username!" },
                ]}
              >
                <Input prefix={<UserOutlined />} placeholder="Username" />
              </Form.Item>
              <Form.Item
                name="password"
                rules={[
                  { required: true, message: "Please input your Password!" },
                ]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="Password"
                />
              </Form.Item>
              <Form.Item>
                <Link href="#" className="forgot-link">
                  Forgot Password?
                </Link>
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" block>
                  Log in
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Login;
